export enum LikeInteraction {
  unlike = -1,
  like = 1,
}

export interface RecordInteractionRequest {
  post: string;
  user?: string;
  like?: LikeInteraction;
}

export interface UserLikePostStatusRequest {
  post: string;
  user: string;
}

export interface UserLikePostStatusResponse {
  post: string;
  user: string;
  liked: boolean;
}
